module.exports = __webpack_public_path__ + "static/media/security-bank.1da04e98.png";